module.exports = __webpack_public_path__ + "static/media/Icon_Standby_Grey70.df6a2547.png";